export type TranslationObject = {
  [value in TranslationKeys]?: string;
};
export enum TranslationKeys {
  EN = 'en',
  SV = 'sv',
}

export type Translation = 'en' | 'sv';
